import { CandidateType } from '../types/candidate-type';

export const getCandidateTypeFromCode = (candidateCode?: string) => {
	if (!candidateCode) return CandidateType.TALENTS_ARENA;
	const acpcPattern = /^acpc\d*$/i;
	const psutPattern = /^psut\d*$/i;
	if (acpcPattern.test(candidateCode)) return CandidateType.ACPC;
	if (psutPattern.test(candidateCode)) return CandidateType.PSUT;
	return CandidateType.TALENTS_ARENA;
};
